module.exports = __webpack_public_path__ + "media/images/ticket/set_order_ov-24849f95b62308b120e4db4bc9a4e96b.png";